import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { StyledFilterBox, StyledImageContainer } from '../../style'
import Link from 'next/link'

const JoinUs: React.FC = () => {
  return (
    <StyledFilterBox>
      <Stack maxWidth={205} spacing={1.25}>
        <Typography variant="body_m_medium">Join Us?</Typography>
        <Typography variant="body_s_regular">
          Sign up to be matched with the jobs that best suit you among millions
          of jobs.
        </Typography>
      </Stack>
      <Box mt={3.75}>
        <Link href={'/auth/register'}>
          <Button>Sign Up</Button>
        </Link>
      </Box>
      <StyledImageContainer />
    </StyledFilterBox>
  )
}

export default JoinUs
